/**
 * Returns in value of css variables
 *
 * @param property The value of the property
 */
export function getPropertyValue(property) {
  try {
    const value = getComputedStyle(document.documentElement).getPropertyValue(property);
    return value;
  } catch (error) {
    throw new Error(error);
  }
}